import { render, staticRenderFns } from "./SessionDetails.vue?vue&type=template&id=1b48fc5f&scoped=true"
import script from "./SessionDetails.vue?vue&type=script&lang=js"
export * from "./SessionDetails.vue?vue&type=script&lang=js"
import style0 from "./SessionDetails.vue?vue&type=style&index=0&id=1b48fc5f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b48fc5f",
  null
  
)

export default component.exports